/** biome-ignore-all lint/suspicious/noExplicitAny: redux UI-state only reducer */
import { LOSS_AND_DAMAGE_FILTER_TYPES } from '@/views/screens/Claims/constants';
import type { LossAndDamageFilterType, LossAndDamageSearchFilters } from '@/views/screens/Claims/types';

import { LOSS_AND_DAMAGE_CLAIMS_FILTERS_INITIAL_DATA } from '../../../contants/ClaimsEnums';
import { SEARCH_VIEW_TYPES, type SearchViewType } from '../../../contants/common';
import { LossAndDamageClaimsTypes } from './LossAndDamageClaimsTypes';

export interface LossAndDamageClaimsState {
  filters: LossAndDamageSearchFilters;
  filterType: LossAndDamageFilterType;
  editDrawer: boolean;
  selectedClaimKey: number | undefined;
  selectedClaims: number[];
  claimViewMode: SearchViewType;
}

const initialState: LossAndDamageClaimsState = {
  claimViewMode: SEARCH_VIEW_TYPES.CARD,
  editDrawer: false,
  filters: LOSS_AND_DAMAGE_CLAIMS_FILTERS_INITIAL_DATA,
  filterType: LOSS_AND_DAMAGE_FILTER_TYPES.BASIC,
  selectedClaimKey: undefined,
  selectedClaims: [],
};

const LossAndDamageClaimsReducer = (state = initialState, { type, payload }: any): LossAndDamageClaimsState => {
  switch (type) {
    case LossAndDamageClaimsTypes.SET_CLAIMS_FILTERS: {
      return {
        ...state,
        filters: { ...state.filters, ...payload },
      };
    }
    case LossAndDamageClaimsTypes.SET_FILTER_TYPE: {
      return {
        ...state,
        filterType: payload,
      };
    }
    case LossAndDamageClaimsTypes.SET_SELECTED_CLAIMS: {
      return {
        ...state,
        selectedClaims: payload,
      };
    }
    case LossAndDamageClaimsTypes.SET_SELECTED_CLAIM_KEY: {
      return {
        ...state,
        selectedClaimKey: payload,
      };
    }
    case LossAndDamageClaimsTypes.SET_CLAIM_EDIT_DRAWER: {
      return {
        ...state,
        editDrawer: payload,
      };
    }

    case LossAndDamageClaimsTypes.SET_CLAIM_SEARCH_VIEW_TYPE_INITIAL:
    case LossAndDamageClaimsTypes.SET_CLAIM_SEARCH_VIEW_TYPE: {
      return {
        ...state,
        claimViewMode: payload,
      };
    }

    default:
      return state;
  }
};

// biome-ignore lint/style/noDefaultExport: redux will be migrated to react-query
export default LossAndDamageClaimsReducer;
